module.exports = __webpack_public_path__ + "img/winners5.55c138ab.svg";